import React from 'react';
import CreateClassroomModal from '../CreateClassroomModal';
import { ClassroomModalVariant } from '../../../types';

export interface BaseClassroomModalProps {
  classroomModalView: ClassroomModalVariant;
  handleClose: (parmas?: any) => void;
}

const getModal = (
  classroomModalView: ClassroomModalVariant,
  handleClose: () => void
): JSX.Element => {
  switch (classroomModalView) {
    case ClassroomModalVariant.CREATE: {
      return <CreateClassroomModal step={0} onClose={handleClose} />;
    }
    default:
      throw new Error(`No case match for ${classroomModalView}!`);
  }
};

const BaseClassroomModal: React.FC<BaseClassroomModalProps> = ({
  classroomModalView,
  handleClose
}) => {
  return getModal(classroomModalView, handleClose);
};
export default BaseClassroomModal;
